export const MAX_PHONE_EXTENSION_LENGTH = 10;

export const sanitizePhoneExtension = (value: string): string =>
  value.replace(/\D/g, '').slice(0, MAX_PHONE_EXTENSION_LENGTH);
